import './logo.styl';
import React from 'react';
import classNames from 'classnames';

export default class Logo extends React.Component {
  state = {
    inited: false
  };

  componentDidMount() {
    setTimeout(() => this.setState({inited: true}), 100);
  }

  render() {
    const {inited} = this.state;

    return (
      <div
        className={classNames({
          logo: true,
          logo_status0: !inited,
          logo_status1: inited,
        })}
      >
        <div className="logo__glow">
          <img src={require('./page2_glow.png')} />
        </div>
        <div className="logo__glowlogo">
          <img src={require('./logo.png')} />
        </div>

        <div className="logo__main">
          <ul>
            <li>
          <span>
            <img className="round" src={require('./ttround.png')} />
          </span>
            </li>
            <li>
          <span>
            <img className="round" src={require('./ttround.png')} />
          </span>
            </li>
            <li>
          <span>
            <img className="round" src={require('./ttround.png')} />
          </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/components/logo/Logo.js